/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_DiffingInputs */

const en_svchip_diffing = /** @type {(inputs: Svchip_DiffingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diffing`)
};

const ar_svchip_diffing = /** @type {(inputs: Svchip_DiffingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المقارنة`)
};

const bn_svchip_diffing = /** @type {(inputs: Svchip_DiffingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিফিং`)
};

const de_svchip_diffing = /** @type {(inputs: Svchip_DiffingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abweichend`)
};

const es_svchip_diffing = /** @type {(inputs: Svchip_DiffingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferenciando`)
};

const fr_svchip_diffing = /** @type {(inputs: Svchip_DiffingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Différent`)
};

const pt_svchip_diffing = /** @type {(inputs: Svchip_DiffingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferença`)
};

const zh_svchip_diffing = /** @type {(inputs: Svchip_DiffingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较`)
};

const tr_svchip_diffing = /** @type {(inputs: Svchip_DiffingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farklılık`)
};

const ru_svchip_diffing = /** @type {(inputs: Svchip_DiffingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Различия`)
};

const pl_svchip_diffing = /** @type {(inputs: Svchip_DiffingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Różnica`)
};

/**
* | output |
* | --- |
* | "Diffing" |
*
* @param {Svchip_DiffingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_diffing = /** @type {((inputs?: Svchip_DiffingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_DiffingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_diffing(inputs)
	if (locale === "bn") return bn_svchip_diffing(inputs)
	if (locale === "de") return de_svchip_diffing(inputs)
	if (locale === "es") return es_svchip_diffing(inputs)
	if (locale === "fr") return fr_svchip_diffing(inputs)
	if (locale === "pt") return pt_svchip_diffing(inputs)
	if (locale === "zh") return zh_svchip_diffing(inputs)
	if (locale === "tr") return tr_svchip_diffing(inputs)
	if (locale === "ru") return ru_svchip_diffing(inputs)
	if (locale === "pl") return pl_svchip_diffing(inputs)
	return en_svchip_diffing(inputs)
});